<template>
	<div style="width: 100%; height: 100%;">
		<div style="padding: 6px;font-size: 16px;"
			v-if="isNeedText(selectdItem.compontChildren[0].data.textList.list) == '' && selectdItem.compontChildren[0].data.textList.subList.length == 0 && type != 'build'">
			请添加文本
		</div>
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>

		<div @mouseleave.stop.prevent="enterBgTit = false" @mouseenter.stop.prevent="enterBgTit = true"
			v-if="!selectdItem.compontChildren[0].layoutConfig.expandable" :style="{
			...getBgStyle(),
			...getBorder(),
			...getBorderRadius(),
			...getPadding(),
			...getMargin(),
			alignItems:selectdItem.compontChildren[0].layoutConfig.flex
		}" style="display: flex;flex-direction: column;">
			<div :style="{
				  ...getTit(),
				  ...getTitMargin()
			 }" style="cursor: pointer;" v-if="isNeedText(selectdItem.compontChildren[0].data.textList.list) != ''">
				<div style="white-space:normal;word-wrap: break-word;max-width: 100%;hyphens: auto;word-break: break-all;"
					@click="hrefNavTo(selectdItem.compontChildren[0].data.link)" class="linktit" :style="{
					'--hover':selectdItem.compontChildren[0].layoutConfig.titHoverColor
				}" v-html="getHtml(selectdItem.compontChildren[0].data.textList.list)">
				</div>
			</div>
			<div @click="hrefNavTo(subItem.link)"
				v-for="(subItem,subIndex) in selectdItem.compontChildren[0].data.textList.subList">
				<div style="cursor: pointer;white-space:normal;word-wrap: break-word;max-width: 100%;hyphens: auto;word-break: break-all;"
					@mouseleave="enterSubIndex = -1" @mouseenter.stop.prevent="enterSubIndex = subIndex" :style="{
					...getSubTit(subIndex),
					...getSubTitMargin(),
				}" v-html="getHtml(subItem.list)">
				</div>
			</div>
		</div>


		<div @mouseleave.stop.prevent="enterBgTit = false" @mouseenter.stop.prevent="enterBgTit = true"
			v-if="selectdItem.compontChildren[0].layoutConfig.expandable" :style="{
			...getBgStyle(),
			...getBorder(),
			...getBorderRadius(),
			...getPadding(),
			...getMargin(),
			alignItems:selectdItem.compontChildren[0].layoutConfig.flex
		}" style="display: flex;flex-direction: column;">

			<div :style="{
			  ...getTit(),
			  ...getTitMargin()
		 }" style="cursor: pointer;display: flex;align-items: center;"
				v-if="isNeedText(selectdItem.compontChildren[0].data.textList.list) != ''">
				<div @click="hrefNavTo(selectdItem.compontChildren[0].data.link)" :style="{
			}">
					<div style="white-space:normal;word-wrap: break-word;max-width: 100%;hyphens: auto;word-break: break-all;"
						@mouseenter.stop.prevent="enterTit = true" @mouseleave.stop.prevent="enterTit = false"
						v-html="getHtml(selectdItem.compontChildren[0].data.textList.list)"></div>

				</div>
				<div @click="titShow = !titShow">
					<i @mouseenter.stop.prevent="enterTit = true" @mouseleave.stop.prevent="enterTit = false" :style="{
					}" style="cursor: pointer;" :class="{ 'rotate-180': !titShow, 'rotate-0':titShow}" class="el-icon-arrow-up"></i>
				</div>
			</div>

			<!-- <div style="display: flex;align-items: center;" @click="titShow = !titShow">
				<div>
					测试1
				</div>
				<i :class="{ 'rotate-180': !titShow, 'rotate-0':titShow}" class="el-icon-arrow-up"></i>
			</div> -->

			<transition name="collapse" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave"
				@leave="leave">
				<div v-if="titShow" style="display: flex;flex-direction: column;" :style="{
					alignItems:selectdItem.compontChildren[0].layoutConfig.flex
				}">
					<div @click="hrefNavTo(subItem.link)"
						v-for="(subItem,subIndex) in selectdItem.compontChildren[0].data.textList.subList">
						<div style="cursor: pointer;white-space:normal;word-wrap: break-word;max-width: 100%;hyphens: auto;word-break: break-all;"
							@mouseleave="enterSubIndex = -1" @mouseenter.stop.prevent="enterSubIndex = subIndex" :style="{
							...getSubTit(subIndex),
							...getSubTitMargin(),
						}" v-html="getHtml(subItem.list)">
						</div>
					</div>
				</div>
			</transition>
		</div>

		<!-- <div style="cursor: pointer;" v-if="isNeedText(selectdItem.compontChildren[0].data.textList.list) != ''">
			<div class="linktit" v-html="getHtml(selectdItem.compontChildren[0].data.textList.list)"
				:style="{'--hover': compontentStyle.hoverColor}"
				@click="hrefNavTo(selectdItem.compontChildren[0].data)">
			</div>
		</div> -->
	</div>
</template>

<script>
	import {
		getUrl_name
	} from '../../api/all.js'
	export default {
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				preImg:[],
				enterBgTit: false,
				enterTit: false,
				enterSubIndex: -1,
				loading: false,
				titShow: false,
			}
		},
		mounted() {
			// console.log('selectdItemselectdItemselectdItemselectdItem',this.selectdItem)
			if (!this.selectdItem.compontChildren[0].layoutConfig.titHoverBg) {
				this.$set(this.selectdItem.compontChildren[0].layoutConfig, 'titHoverBg', {
					bg: {
						type: "1", // 1 纯色 2 渐变
						bgColor: "#000",
						gradientColor: "",
						bgImg: "", // 背景图片 3
						bgPosition: "", // 位置 3
						bgImgType: "",
						bgHeight: 0,
						bgWidth: 0
					},
				})
			}
			if (!this.selectdItem.compontChildren[0].layoutConfig.titHoverFontColor) {
				this.$set(this.selectdItem.compontChildren[0].layoutConfig, 'titHoverFontColor', '')
			}
			if (!this.selectdItem.compontChildren[0].layoutConfig.titChildHoverFontColor) {
				this.$set(this.selectdItem.compontChildren[0].layoutConfig, 'titChildHoverFontColor', '')
			}
		},
		methods: {
			preload(list) {
				var images = new Array() 
				for (let i = 0; i <list.length; i++) {
					images[i] = new Image()
					images[i].src = list[i]
				}
			},
			async hrefNavTo(item) {
				console.log('hrefNavToitem', item)
				console.log('hrefNavTo', item)

				if (this.selectdItem.compontChildren[0].layoutConfig.expandable) {
					this.titShow = !this.titShow
				}

				if (this.type == 'design') {
					return
				}

				if (item.cacheLinkIndex == '热销商品') {
					this.$router.push({
						path: '/categories_products/hot'
					})
					this.show = false
					return
				}
				if (item.cacheLinkIndex == '最新商品') {
					this.$router.push({
						path: '/categories_products/new'
					})
					this.show = false
					return
				}

				if (item.cacheLinkIndex == '浏览最多') {
					this.$router.push({
						path: '/categories_products/visit'
					})
					this.show = false
					return
				}
				if (item.cacheLinkIndex == '所有商品') {
					this.$router.push({
						path: '/categories_products/all'
					})
					this.show = false
					return
				}

				if (item.cacheLinkIndex == '首页') {
					this.$router.push({
						path: '/'
					})
					this.show = false
					return
				}


				if (item.cacheLinkIndex == '商品分类') {
					try {
						this.loading = true
						this.show = false
						const urlData = await getUrl_name({
							type: "categories",
							id: item.link.id
						})


						this.$router.push({
							path: '/categories/' + urlData.data.data
						})
						this.loading = false
					} catch (e) {
						this.loading = false
					}
					return
				}
				if (item.cacheLinkIndex == '商品') {

					try {
						this.loading = true
						this.show = false
						const urlData = await getUrl_name({
							type: "products",
							id: item.link.id
						})
						this.$router.push({
							path: '/products/' + urlData.data.data
						})
						this.loading = false
					} catch (e) {
						this.loading = false
					}
					return
				}
				let url = item.link.url
				if (item.link.type == '站内链接') {
					// 判断是否是站内链接
					console.log('item.link', item.link)
					console.log(window.location.host)
					if (item.link.name.indexOf(window.location.host) != -1) {
						let arr = item.link.name.split(window.location.host)
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						return
					} else {
						this.show = false
						window.open(item.link.name);
						return
					}
				}
				this.show = false
				if (url) {
					this.$router.push({
						path: '/' + url,
					})
				}

			},

			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},

			getSubTit(subIndex) {
				let layoutConfig = this.selectdItem.compontChildren[0].layoutConfig
				let color= layoutConfig.subTitColor
				
				
				if(this.enterBgTit){
					if (layoutConfig.titChildHoverFontColor) {
						color = layoutConfig.titChildHoverFontColor
					}
				}
				if(this.enterSubIndex == subIndex) {
					if (layoutConfig.subHoverColor) {
						color = this.enterSubIndex == subIndex ? layoutConfig.subHoverColor : layoutConfig.subTitColor
					}
				}
				
				
				
				


				return {
					fontSize: layoutConfig.subTitSize + 'px',
					color,
					fontWeight: layoutConfig.subTitBold == 'none' ? '' : layoutConfig.subTitBold,
					fontFamily: layoutConfig.subTitFontFamily,
				}
			},
			getSubTitMargin() {
				let margin = this.selectdItem.compontChildren[0].layoutConfig.subTitMargin
				let style = {
					marginTop: margin[0] + 'px',
					marginBottom: margin[1] + 'px',
					marginLeft: margin[2] + 'px',
					marginRight: margin[3] + 'px'
				}
				return style
			},

			getTitMargin() {
				let margin = this.selectdItem.compontChildren[0].layoutConfig.titMargin
				let style = {
					marginTop: margin[0] + 'px',
					marginBottom: margin[1] + 'px',
					marginLeft: margin[2] + 'px',
					marginRight: margin[3] + 'px'
				}
				return style
			},

			getTit() {
				let layoutConfig = this.selectdItem.compontChildren[0].layoutConfig
				let color = layoutConfig.titColor
				if(this.enterBgTit){
					if (this.selectdItem.compontChildren[0].layoutConfig.titHoverFontColor) {
						color = this.selectdItem.compontChildren[0].layoutConfig.titHoverFontColor
						console.log('titShowtitShow', this.titShow)
					}
				}
				if (this.enterTit) {
					if (this.selectdItem.compontChildren[0].layoutConfig.titHoverColor) {
						color = this.selectdItem.compontChildren[0].layoutConfig.titHoverColor
						console.log('titShowtitShow', this.titShow)
					}
				}
				
				

				return {
					fontSize: layoutConfig.titSize + 'px',
					color,
					fontWeight: layoutConfig.titBold == 'none' ? '' : layoutConfig.titBold,
					fontFamily: layoutConfig.titFontFamily,
				}
			},
			getMargin() {
				let margin = this.selectdItem.compontChildren[0].layoutConfig.margin
				let style = {
					marginTop: margin[0] + 'px',
					marginBottom: margin[1] + 'px',
					marginLeft: margin[2] + 'px',
					marginRight: margin[3] + 'px'
				}
				return style
			},

			getPadding() {
				let padding = this.selectdItem.compontChildren[0].layoutConfig.padding
				let style = {
					paddingTop: padding[0] + 'px',
					paddingBottom: padding[1] + 'px',
					paddingLeft: padding[2] + 'px',
					paddingRight: padding[3] + 'px'
				}
				return style
			},

			getBorderRadius() {
				let style = {}
				style.borderRadius =
					`${this.selectdItem.compontChildren[0].layoutConfig.border.borderRadius[0]}px ${this.selectdItem.compontChildren[0].layoutConfig.border.borderRadius[1]}px ${this.selectdItem.compontChildren[0].layoutConfig.border.borderRadius[2]}px ${this.selectdItem.compontChildren[0].layoutConfig.border.borderRadius[3]}px`
				return style
			},

			getBorder() {
				let border = this.selectdItem.compontChildren[0].layoutConfig.border
				if (border.type && border.color) {
					let style = {}
					style.borderTop =
						`${border.type} ${border.borderSize[0]}px ${border.color}`
					style.borderLeft =
						`${border.type} ${border.borderSize[1]}px ${border.color}`
					style.borderBottom =
						`${border.type} ${border.borderSize[2]}px ${border.color}`
					style.borderRight =
						`${border.type} ${border.borderSize[3]}px ${border.color}`
					return style
				}
			},

			bgStyleConfig() {
				let bg = this.selectdItem.compontChildren[0].layoutConfig.bg
				if (bg.type == '1') {
					return {
						backgroundColor: bg.color
					}
				}
				if (bg.type == '2') {
					return this.cssStringToObject(bg.gradientColor)
				}
				if (bg.type == '3') {
					let style = {}
					let backgroundImage = `url(${bg.bgImg})`

					if (bg.bgWidth) {
						style.backgroundSize = bg.bgWidth + 'px';
					} else {
						style.backgroundSize = '100%';
					}
					if (bg.bgHeight) {
						style.backgroundSize = style.backgroundSize + ' ' + (bg.bgHeight +
							'px')
					} else {
						style.backgroundSize = style.backgroundSize + ' 100%'
					}
					if (bg.bgImgType) {
						style.backgroundRepeat = bg.bgImgType
					}
					if (bg.bgPosition) {
						style.backgroundPosition = bg.bgPosition
					}
					style.backgroundImage = backgroundImage
					return style
				}
			},

			getBgStyle(e) {

				if (!this.enterBgTit) {
					let hoverBg = this.selectdItem.compontChildren[0].layoutConfig.titHoverBg.bg
					if(hoverBg.type == '3' && hoverBg.bgImg){
						if(this.preImg.indexOf(hoverBg.bgImg) == -1){
							this.preImg.push(hoverBg.bgImg)
						}
						this.preload(this.preImg)
					}
					
					return this.bgStyleConfig()
				} else {
					let bg = this.selectdItem.compontChildren[0].layoutConfig.bg
					let hoverBg = this.selectdItem.compontChildren[0].layoutConfig.titHoverBg.bg
					if (hoverBg.type == '1' && hoverBg.color) {
						return {
							backgroundColor: hoverBg.color
						}
					}

					if (hoverBg.type == '2' && hoverBg.gradientColor) {
						return this.cssStringToObject(hoverBg.gradientColor)
					}

					if (hoverBg.type == '3' && hoverBg.bgImg) {
						let style = {}
						let backgroundImage = `url(${hoverBg.bgImg})`

						if (hoverBg.bgWidth) {
							style.backgroundSize = hoverBg.bgWidth + 'px';
						} else {
							style.backgroundSize = '100%';
						}
						if (hoverBg.bgHeight) {
							style.backgroundSize = style.backgroundSize + ' ' + (hoverBg.bgHeight +
								'px')
						} else {
							style.backgroundSize = style.backgroundSize + ' 100%'
						}
						if (hoverBg.bgImgType) {
							style.backgroundRepeat = hoverBg.bgImgType
						}
						if (hoverBg.bgPosition) {
							style.backgroundPosition = hoverBg.bgPosition
						}
						style.backgroundImage = backgroundImage
						console.log('stylestyle123456', style)
						return style
					}

					return this.bgStyleConfig()

				}

			},



			beforeEnter(el) {
				el.style.height = '0'
			},
			enter(el) {
				el.style.height = el.scrollHeight + 'px'
			},
			beforeLeave(el) {
				el.style.height = el.scrollHeight + 'px'
			},
			leave(el) {
				setTimeout(() => {
					el.style.height = '0'
				})
			},
			getHtml(list) {
				console.log('systemConfigsystemConfigsystemConfig', this.systemConfig)
				let text = ''
				for (let i = 0; i < list.length; i++) {
					if (this.systemConfig.locale == list[i].language) {
						if (list[i].text != '') {
							text = list[i].text
						}
					}

				}
				return text
			},
			isNeedText(e) {
				let text = ''
				e.forEach(item => {
					if (item.text != '') {
						text = item.text
					}
				})
				console.log('texttexttext', text)
				return text
			}
		}
	}
</script>

<style scoped lang="scss">
	.linktit:hover {
		cursor: pointer;
		color: var(--hover);
	}

	.linktitT:hover {
		cursor: pointer;
		color: '#00aaff';
	}

	.collapse-enter-active,
	.collapse-leave-active {
		transition: height 0.3s ease;
		overflow: hidden;
	}

	.rotate-180 {
		transform: rotate(180deg);
		transition: transform 0.3s ease;
	}

	.rotate-0 {
		transform: rotate(0deg);
		transition: transform 0.3s ease;
	}
</style>